import { useEffect, useState } from "react";
import {
  Box,
  Drawer,
  Grid2,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Typography
} from "@mui/material";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { CustomButton, CustomButtonContained, CustomButtonOutline } from "../shared/utils/CustomButton";
import MenuIcon from "@mui/icons-material/Menu";
import useResponsive from "../shared/utils/Responsive";
import { Constants, Dashboard_URL, Page_Padding, Skillvation_Dashboard_URL, ssoLoginUrl } from "../shared/constants";
import { AiFillAndroid, AiFillApple } from "react-icons/ai";
import useAuthStore from "../shared/store/useAuthStore";
import MainDialogBox from "../shared/components/Dialog/DialogMainBox";
import { useDialog } from "../shared/hook/useDialog";

import useApartmentPathStore from "../shared/store/useApartmentPathStore";
import { useSlotStore } from "../shared/store/useSlotStore";
import { useSloteDateStore } from "../shared/store/useSloteDateStore";
import { useGetNavbarDetail } from "../assets/nodeApi/getApi/ContentGetApi";

const Navbar = () => {
  const { logout } = useAuthStore();
  const { data: navbarData, isLoading: isNavbarDataLoading } = useGetNavbarDetail()
  const { clearDate } = useSloteDateStore();
  const navigate = useNavigate();
  const token = useAuthStore((state) => state.accessToken);

  const { open: openDialog, handleClickOpen, handleClose } = useDialog();
  const isSmallScreen = useResponsive("lg")
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const toggleDrawer = (newOpen) => () => setOpen(newOpen);
  const user = useAuthStore((state) => state.user);

  const { clearAllSlots } = useSlotStore()
  const isAiEdge = location.pathname === "/AiEdge" || location.pathname === "/SummerCamp";

  useEffect(() => {
    clearAllSlots()
    clearDate()
  }, [location.pathname]);

  const handleOpenDashboard = () => {
    const role = user?.role?.toLowerCase();
    if (role === "school" || role === "teacher" ||  role === "publisher" || role=="sv_student") {
      window.location.href = Skillvation_Dashboard_URL || "https://devdashboard.skillvation.com/";
      return;
    }
    if (!Dashboard_URL) return;
    const showPopup = user?.role === "organizer" && useApartmentPathStore.getState().consumeApartmentPath() === "/ApartmentSignUp";
    if (showPopup) {
      useApartmentPathStore.getState().resetApartmentPath();
      const url2 = new URL(`${Dashboard_URL}apartment/dashbaord`);
      url2.searchParams.set("showPopup", "true");
      window.location.href = url2.toString();
    } else {
      window.location.href = Dashboard_URL;
    }
  };


  // const menuItems = [
  //   { text: "Courses", link: "/Courses", description: "Explore our latest courses", isExternal: false },
  //   { text: "Skill2Skool", link: "/SkillToSchool", description: "", isExternal: false },
  //   { text: "Skillbox", link: "/SkillBox", description: "", isExternal: false },
  //   { text: "Skill4Teachers", link: "/SkillFourTeachers", description: "", isExternal: false },
  //   { text: "Events", link: "/Events", description: "Explore our latest events", isExternal: false },
  //   // { text: " Pro", link: proSkillUrl, description: "", isExternal: true },
  //   // { text: "Times", link: `${Main_URL}times/`, description: "", isExternal: true },
  //   // { text: "Shop", link: `${Main_URL}shop/`, description: "", isExternal: true },
  //   // { text: "On Boarding", link: "/Apartmentonboarding", description: "Onboard with us quickly" },
  // ];

  const menuItems = navbarData?.navLinks


  const RenderMenuList = () => (

    <List sx={{ display: "flex", flexDirection: isSmallScreen ? "column" : "row", gap: "1rem" }}>
      {menuItems?.map((item, index) => (
        <>

          {item?.isEnabled && <ListItem key={index} sx={{ width: "auto" }}>
            <Link to={item.url} style={{ textDecoration: "none", color: "inherit" }}
              target={item.isExternal ? "_blank" : "_self"}
              rel={item.isExternal ? "noopener noreferrer" : ""}
            >
              <Typography variant="body2" fontSize={"14px"} color={location.pathname === item.link ? "red.main" : "inherit"}>{item.label}</Typography>
            </Link>
          </ListItem>

          }
        </>

      ))}
    </List>
  );


  const MiddleList = () => {
    return (
      <List sx={{ width: "100%", borderRadius: 2 }}>
        {menuItems?.map((item, index) => (
          <>

            {item?.isEnabled && <ListItem
              key={index}
              button
              component={Link}
              to={item.url}
              onClick={() => setOpen(false)}
              sx={{ borderBottom: "1px solid #E5E5E5", flexDirection: "column", py: 1.5 }}
            >
              <ListItemText primary={<Typography variant="h6" fontSize={"18px"} textAlign={"center"}>{item.label}</Typography>} />
              {item.description && (
                <Typography variant="body2" fontSize={"12px"} sx={{ color: "grey.200", }} textAlign={"center"}>
                  {item.description}
                </Typography>
              )}
            </ListItem>}
          </>

        ))}
        <ListItem
          button
          component={Link}
          to="/login"
          onClick={() => setOpen(false)}
          sx={{ borderBottom: "1px solid #E5E5E5", flexDirection: "column", py: 1.5 }}
        >
          <ListItemText primary={<Typography variant="h6" fontSize={"18px"} textAlign={"center"}>School Login</Typography>} />
        </ListItem>
        <ListItem
          button
          component={Link}
          to="/TeacherLogin"
          onClick={() => setOpen(false)}
          sx={{ borderBottom: "1px solid #E5E5E5", flexDirection: "column", py: 1.5 }}
        >
          <ListItemText primary={<Typography variant="h6" fontSize={"18px"} textAlign={"center"}>Teacher Login</Typography>} />
        </ListItem>
      </List>
    );
  };

  const ButtonList = () => {
    return (
      <Box display="flex" gap={2}>
        {
          !token ? <>
            <CustomButton buttonText={"Sign Up"} onClick={() => { navigate("/SelectSignupPath") }} variant={"contained"} />
            <CustomButton buttonText={"Log In"} onClick={() => { navigate("/SelectLoginPath") }} variant={"outlined"} />
            {/* <CustomButton buttonText={"SSO Log In "} onClick={() => { navigate("http://localhost:5173/") }} variant={"outlined"} /> */}
            <a
              href={ssoLoginUrl}
              style={{ textDecoration: "none" }}
            >
              <CustomButton
                buttonText={"SSO Log In"}
                variant={"outlined"}
              />
            </a>
          </> : <>
            <CustomButton buttonText={"Dashboard"} onClick={handleOpenDashboard} variant={"contained"} />
            <CustomButton buttonText={"Log Out"} onClick={handleClickOpen} variant={"outlined"} />
          </>


        }
      </Box>
    )
  }

  const DrawerList = () => (
    <Box sx={{ width: "300px", display: "flex", flexDirection: "column", justifyContent: "space-between", minHeight: "100vh", pb: 2 }} role="presentation"

      onClick={(e) => {
        const tag = e.target.closest("a");
        if (!tag) {
          toggleDrawer(false)();
        }
      }}

    >
      <Grid2
        container
        sx={{
          backgroundImage: `linear-gradient(109.92deg, rgba(0, 0, 0, 0) -18.13%, rgba(0, 0, 0, 0.8) 95.24%), url(${Constants.customImages.SidebarImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "200px", // Adjust height as needed
          position: "relative",
          px: "20px"

        }}
      >
        <Grid2 children xs={12} sx={{ position: "relative", zIndex: 1, display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
          <Typography variant="body1" textAlign={"center"} color="primary.main" gutterBottom>
            Ready to explore? Log in and let’s go!"
          </Typography>
          <ButtonList />

        </Grid2>
      </Grid2>
      <MiddleList />
      <Box display="flex" justifyContent="center" alignItems={"center"} flexDirection={"column"} >
        <img src={Constants.customImages.SiblingPlaying} width={"40%"} />
        <Box mt={1}>
          <Typography variant="body1" gutterBottom>
            Available On
          </Typography>
          <Box display="flex" gap={1} justifyContent={"center"}>
            <AiFillAndroid style={{
              fontSize: "30px",
              color: "#DC143C",
            }} />
            <AiFillApple style={{
              fontSize: "30px",
              color: "#DC143C",
            }} />
          </Box>
        </Box>
      </Box>
    </Box>
  );

  return (
    <>
      {!isSmallScreen && (
        <Box
          sx={{
            position: isAiEdge ? "absolute" : "relative",
            width: "100%",
            top: 0,
            left: 0,
            zIndex: 10,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              py: 1,
              px: Page_Padding,
            }}
          >
            <Link to="/">
              <img
                src={Constants.customImages.Logo}
                alt="logo"
                width="200px"
                height="auto"
              />
            </Link>

            <RenderMenuList />

            <ButtonList />
          </Box>
        </Box>


      )}

      {isSmallScreen && (
        <Box
          sx={{
            position: isAiEdge ? "absolute" : "relative",
            width: "100%",
            top: 0,
            left: 0,
            zIndex: 10,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              py: 1,
              px: Page_Padding,
            }}
          >
            <IconButton onClick={toggleDrawer(true)}>
              <MenuIcon sx={{ color: "#000", fontSize: "20px" }} />
            </IconButton>
            <Link to={'/'}><img src={Constants.customImages.Logo} alt="logo" width={"100px"} height={"auto"} /></Link>
          </Box>
        </Box>


      )}
      {/* {isSmallScreen && (
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", bgcolor: "primary.main", position: "sticky", top: 0, zIndex: 1000, px: 1 }}>
          <IconButton onClick={toggleDrawer(true)}>
            <MenuIcon sx={{ color: "#000", fontSize: "20px" }} />
          </IconButton>
          <Link to={'/'}><img src={Constants.customImages.Logo} alt="logo" width={"100px"} height={"auto"} /></Link>
        </Box>
      )} */}
      <Drawer open={open} onClose={toggleDrawer(false)}>
        <DrawerList />
      </Drawer>
      <MainDialogBox open={openDialog} handleClose={handleClose} width={"30%"}>
        <Typography variant="h5" textAlign={"center"}>Are you sure you want to Log Out?</Typography>
        <Box display="flex" justifyContent={"center"} gap={2} mt={5}>
          <CustomButtonContained buttonText="Cancel" onClick={handleClose} />
          <CustomButtonOutline buttonText="Log Out" onClick={() => {
            // useAuthStore.getState().logout(navigate);
            logout()
            handleClose();
            navigate("/SelectLoginPath")

          }} />
        </Box>
      </MainDialogBox>
    </>
  );
};

export default Navbar;
